import React from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";

const pageView = {
  first: {
    mfooter: 80, // 모바일 푸터
    tfooter: 96, // 테블릿 푸터
  },
};
const { mfooter, tfooter } = pageView.first;
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  header: {
    height: "auto",
  },
  body: {
    [theme.breakpoints.down("md")]: {
      width: "100%",
      overflowY: "scroll",
      height: `calc(100vh - ${tfooter}px)`,
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      height: `calc(100vh - ${mfooter}px)`,
    },
  },
  footer: {
    height: 80,
    [theme.breakpoints.down("md")]: {
      position: "fixed",
      height: tfooter,
      backgroundColor: theme.palette.background.default,
      bottom: 0,
    },
    [theme.breakpoints.down("sm")]: {
      height: mfooter,
    },
  },
}));
const MainLayout = ({ cancer = "폐암", header, footer, children }) => {
  const classes = useStyles();
  return (
    <Grid container direction="column" className={classes.root}>
      <Grid className={classes.body}>
        <Grid container className={classes.header}>
          {header}
        </Grid>
        {children}
      </Grid>

      <Grid
        container
        justify="center"
        alignItems="center"
        className={classes.footer}
      >
        {footer}
      </Grid>
    </Grid>
  );
};

export default MainLayout;
